import { useCallback } from 'preact/hooks';

import { useJWPlayerEvent } from './useJWPlayerEvent';
import { useTracker } from './useTracker';

/**
 * Tracks playback quality changes reported by JWPlayer's `visualQuality` event.
 * The initial level selection is intentionally skipped.
 */
export const useQualityChangeTracking = () => {
  const { trackButtonClick } = useTracker();

  const handleVisualQuality = useCallback(
    ({ reason, mode, level }: jwplayer.VisualQualityParam) => {
      if (reason === 'initial choice') {
        return;
      }

      const { label, width, height } = level ?? ({} as Partial<typeof level>);

      trackButtonClick(
        { title: 'quality', elementIdentifier: 'menu-button-quality' },
        undefined,
        {
          'spt:videoQuality': {
            label,
            resolution: `${width}x${height}`,
            selection: mode === 'auto' ? 'auto' : 'manual',
          },
        }
      );
    },
    [trackButtonClick]
  );

  useJWPlayerEvent('visualQuality', handleVisualQuality);
};
